import SocialLinks from './social-links'

export default SocialLinks
